export const arrayToPairs = <I>(content: I[]): [I, I][] => {
  return content.reduce((result, value, index, array) => {
    if (index % 2 === 0) {
      // @ts-ignore
      result.push(array.slice(index, index + 2));
    }

    return result;
  }, []);
};
